export default __webpack_public_path__ + "static/media/torso-low-front.698ca78c.png";